import React, { useCallback } from 'react'
import { connect } from 'react-redux'
import * as actions from '../redux/actions'
import sendMessageWPP from '../services/sendMessageWPP'
import sendMessageEmail from '../services/sendMessageEmail'
import Header from '../components/Header'
import { FiArrowLeft, FiMail } from 'react-icons/fi'
import { FaWhatsapp } from 'react-icons/fa'
import text from '../constants/Menu'
import { useHistory } from 'react-router-dom'
import '../styles/containers/Perfil.css'
import useLanguage from '../hooks/useLanguage'
import MenuButton from '../components/MenuButton'
import '../styles/containers/Menu.css'
import { supportPhone, supportEmail } from '../services/defaultProps'

const Suport = props => {
  const { push } = useHistory()

  const language = useLanguage()

  const sendWhatsappMessage = useCallback(() => sendMessageWPP(supportPhone, `Olá, sou cliente Mosty. Me chamo ${props.user.name} e desejo falar com o suporte`), [props.user.name])
  const sendEmailMessage = useCallback(() => sendMessageEmail(supportEmail, 'Suporte cliente - MOSTY', `Olá, sou cliente Mosty. Me chamo ${props.user.name} e desejo falar com o suporte`), [props.user.name])

  return (
    <div className='perfil-screen-container'>
      <Header language={language} />
      <div className='perfil-screen-title'>
        <FiArrowLeft onClick={() => push('/')}
          size={24} color='var(--primary)' className='perfil-screen-goback' />
        <p>{text.support[language]}</p>
      </div>
      <div className='perfil-screen-notconfigured'>
        <div className='menu-screen-footer'>
          <h2 style={{ marginBottom: '20px' }}>Contatar suporte via whatsapp: </h2>
          <MenuButton backgroundColor='var(--lightgreen)' Icon={FaWhatsapp} onClick={sendWhatsappMessage}>{text.support[language]}</MenuButton>
        </div>
        <div className='menu-screen-footer' style={{ marginLeft: '20px' }}>
          <h2 style={{ marginBottom: '20px' }}>Contatar suporte via e-mail: </h2>
          <MenuButton backgroundColor='var(--gray)' Icon={FiMail} onClick={sendEmailMessage}>{text.support[language] + ' via e-mail'}</MenuButton>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    ...state.userReducer
  }
}

export default connect(mapStateToProps, actions)(Suport)



// WEBPACK FOOTER //
// ./src/containers/Support.js